import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "@phosphor-icons/react";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation("common");

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="text-center">
        <h1 className="text-8xl font-bold text-muted-foreground/30 mb-2">
          404
        </h1>
        <p className="text-lg text-muted-foreground mb-8">
          {t("notFound.message")}
        </p>
        <Button asChild variant="outline" className="gap-2">
          <a href="/">
            <ArrowLeft className="rtl:-scale-x-100" size={16} />
            {t("notFound.back")}
          </a>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
